// Modul zur Anzeige des Moduls Personalkosten mit Perioden
"use strict";

import module from "./module.js";
import "./tests.spec.js";

export default module;
